import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './avatar.component.scss',
  templateUrl: './avatar.component.html',
})
export class AvatarComponent {
  name = input.required<string>();

  protected initials = computed(() => {
    const cleanName = this.name().trim();

    if (!cleanName) return 'A';

    const words = cleanName.split(/\s+/);

    if (words.length === 1) {
      return (words[0]?.[0] ?? 'A').toUpperCase();
    }

    const firstLetter = words[0]?.[0] ?? '';
    const secondLetter = words[1]?.[0] ?? '';

    return (firstLetter + secondLetter).toUpperCase();
  });
}
